var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    callback: _vm.onVisibilityChanged,
    throttle: 100,
    intersection: { threshold: 1 }
  }),expression:"{\n    callback: onVisibilityChanged,\n    throttle: 100,\n    intersection: { threshold: 1 }\n  }"}],class:[_vm.$style.content, ( _obj = {}, _obj[_vm.$style.content_NO_BUTTON] = !_vm.propsData.button, _obj )]},[_c('h3',{ref:"title",class:_vm.$style.title},[_vm._v(_vm._s(_vm.propsData.title))]),_vm._v(" "),(_vm.propsData.button)?_c('div',{ref:"button",class:_vm.$style.button},[_c('nav-link',{staticClass:"btn btn--outline"},[_vm._v("\n      "+_vm._s(_vm.propsData.button.label)+"\n    ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }